export function buildDropDown(obj: any[], name_column: string | number | null = null) {
   return obj
      .filter((h: any) => typeof h == 'object' && h)
      .map((h: any) => ({
         value: h.d_id || h.o_id || h.id || h.value,
         text: name_column && h[name_column] ? h[name_column] : h.o_name || h.d_name || h.text,
      }));
}

export function unixDateToTime(v: number) {
   return v * 24 * 3600;
}
